export default "__VITE_ASSET__D6dxj9XL__"